import { Selector } from "@reduxjs/toolkit";

import { Annotation } from "@com.mgmtp.a12.base/base-model-api/lib/main/header";
import { ModelPath } from "@com.mgmtp.a12.base/base-model-api/lib/main/model";
import {
	EngineStore,
	ModelSelectors,
	UiStateSelectors
} from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormEngineSelectors } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { ReadonlyObjectMap } from "@com.mgmtp.a12.formengine/formengine-core/lib/models/internal/utils/json";

import { getButtonAnnotations } from "../modelHelpers";

export const ModulfUiSelectors = {
	selectValidationMessages: (
		activityId: string
	): Selector<any, ReadonlyObjectMap<EngineStore.Validation.Entry>, never> => {
		return state => {
			const engineState = FormEngineSelectors.engineState(activityId)(state);
			return engineState ? UiStateSelectors.messages()(engineState) : {};
		};
	},
	selectIsReadonly(activityId: string | undefined): Selector<any, boolean, never> {
		return state => {
			const engineState = FormEngineSelectors.engineState(activityId ?? "")(state);
			return engineState ? UiStateSelectors.readonly()(engineState) : false;
		};
	},
	selectButtonAnnotations(
		activityId: string,
		buttonPath: ModelPath
	): Selector<any, ReadonlyArray<Annotation>, never> {
		return state => {
			if (buttonPath.length === 0) {
				// no button path means no EventButtonContext (e.g. a plain, non-event button) -> no annotations to resolve
				return [];
			}
			const engineState = FormEngineSelectors.engineState(activityId)(state);
			return engineState ? getButtonAnnotations(ModelSelectors.formModel()(engineState), buttonPath) : [];
		};
	}
};
